<p>2022</p>
<p>A video essay on a fruit-diet-turned-cult, and what it means to have influence</p>
<app-embedded-video [videoId]="videoId"></app-embedded-video>
